export default {
    key: 'for-resellers',
    path: '/for-resellers',
    name: 'for-resellers',
    component: () => import(/* webpackChunkName: "for-resellers" */ '@/modules/documentation/pages/for-resellers/index.vue'),
    children: [
        {
            key: 'for-resellers-how-to-use-new-styles',
            path: 'how-to-use-new-styles',
            name: 'how-to-use-new-styles',
            component: () =>
                import(/* webpackChunkName: "how-to-use-new-styles" */ '@/modules/documentation/pages/for-resellers/how-to-use-new-styles.vue')
        },
        {
            key: 'for-resellers-form-page-example',
            path: 'form-page-example',
            name: 'form-page-example',
            component: () =>
                import(/* webpackChunkName: "form-page-example" */ '@/modules/documentation/pages/for-resellers/form-page-example.vue')
        },
        {
            key: 'for-resellers-list-page-example',
            path: 'list-page-example',
            name: 'list-page-example',
            component: () =>
                import(/* webpackChunkName: "list-page-example" */ '@/modules/documentation/pages/for-resellers/list-page-example.vue')
        }
    ]
};
